import { signInWithEmailAndPassword } from '@firebase/auth'
import { FC, useCallback, useState } from 'react'
import { auth, transformFirebaseAuthError } from 'services/firebase'
import LoginForm from './login-form'
import { config } from 'config'
import WecLogo from 'assets/logo-fiawec.png'

export type LoginFormValues = {
  email: string
  password: string
}

export interface LoginPageProps {}

export const LoginPage: FC<LoginPageProps> = (props) => {
  const [error, setError] = useState<Error>()
  const handleSubmit = useCallback(
    async ({ email, password }: LoginFormValues) => {
      try {
        await signInWithEmailAndPassword(auth, email, password)
      } catch (error) {
        setError(transformFirebaseAuthError(error))
      }
    },
    [],
  )
  const mainBackgroundClass = config.isWecRedbutton
    ? 'bg-mainBackground_wec'
    : 'bg-mainBackground'

  return (
    <div className={`flex flex-col  ${mainBackgroundClass}`}>
      {config.isWecRedbutton && (
        <div className={`flex items-center self-center w-32 h-full mt-12`}>
          <a href="https://fiawec.tv/" rel="noreferrer">
            <img
              src={WecLogo}
              alt="wec logo"
              className="float-right object-contain h-full"
            />
          </a>
        </div>
      )}
      <div
        className={`w-screen h-screen flex items-center justify-center ${mainBackgroundClass}`}
      >
        <div className="flex flex-col max-w-md p-4 space-y-2 border rounded-lg w-72">
          <LoginForm onSubmit={handleSubmit} />
          <div className="self-center text-red-500">{error?.message}</div>
        </div>
      </div>
    </div>
  )
}
